import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comman-queue',
  templateUrl: './comman-queue.component.html',
  styleUrls: ['./comman-queue.component.scss']
})
export class CommanQueueComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/comman-queue/comman-queue.component.ts